
import { TravelCard } from "../../../components/locations/TravelCard";
import { RajasthanImages } from "../../../media/rajasthan/RajasthanImages";
import PackCard from "../../../components/locations/PackCard";
import contactimg from "../../../media/contactus.png";
import { Link } from "react-router-dom";
import '../MukhaFall/MukhaFall.css';
import { BookSection } from "../../../components/BookSection";

export const ShivDwarTemple=()=>{
    return (
       <div className="mukha-fall-container">
         <div className="fancy-heading">
           <h1>Shivdwar</h1>
           <p className="sub-heading">11th Century Temple of Lord Shiva and Goddess Parvati</p>
         </div>
         <div className="description">
         This ancient but excellent shiv mandir is about 40km north-west from district headquarter and 10 km from Ghorawal. This stupendous shiv temple contains the astounding blackstone idol of shiv and parvati in the procreational posture which is 3 ft high.Quite a good number of black and brown stone idols are also kept nearby. It appears that this might have been a great place for shiv sadhna. Shivratri is the main festival and there is huge gathering on this occasion. Throughout sawan there is a tradition of Jalabhishek by kawariyas. People flock from different parts of the country to worship lord Shiva over there. There is a museum run by department of archaeology containing numerous idols collected from adjoining areas.
          </div>
         <div className="image-gallery">
           <div className="image-item">
             <img
               src={require('../../../media/tourism/Shiv Dwar/shiv1.jpg')}
               alt="Mukha Fall 1"
               className="gallery-image"
             />
             {/* <p className="image-caption">The mesmerizing first view of Mukha Fall.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/Shiv Dwar/shiv2.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/Shiv Dwar/shiv3.jpg')}
               alt="Mukha Fall 3"
               className="gallery-image"
             />
             {/* <p className="image-caption">The lush green surroundings of Mukha Fall.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/Shiv Dwar/shiv4.jpg')}
               alt="Mukha Fall 4"
               className="gallery-image"
             />
             {/* <p className="image-caption">The tranquil ambiance at sunset.</p> */}
           </div>
           <div className="image-item">
             
             {/* <p className="image-caption">A panoramic view of Mukha Fall's beauty.</p> */}
           </div>
         </div>
   
         <BookSection />
       </div>
     );
};